import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article6() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });
  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });

  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img1 = document.getElementById("img2");
      img1.className = '';
      return "";
    }
    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';

      return "";
    }

  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article7');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article5');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article6-left-img1.jpg")} />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article6-left-img2.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article6-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="" ref={firstContainer}>
              <motion.div
                variants={textAnimate}
              >
                <h1 className="f-lora fs-xl mb-4">The Wintering <br />Geese of Islay</h1>
                <h6 className="f-lora-i lh-sm mb-3" variants={textAnimate}>Autumn is a season of change: leaves are shed, fires lit, fungi flourish, ghost stories are shared, and our skies buzz with migrating birds. Here in the Inner Hebrides, tens of thousands of geese journey back to us. Travelling from Greenland each year, these noisy birds make their annual pilgrimage back to the Isle of Islay, escaping the harsh winter of their arctic breeding grounds for a milder Hebridean one.</h6>
                <h6 className="f-lora-i" variants={textAnimate}>words & photography by David Dinsley</h6>
              </motion.div>
              
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <p className="mb-4">This seasonal surge of geese is a spectacle to behold, with wave after wave of them arriving around early October. Arriving from the north, with Mull to their rear, they begin their descent into the mouth of Loch Gruinart and on towards the head of the loch, where they arrive on the Gruinart flats. In a matter of just a few weeks, Loch Gruinart is completely transformed into a hive of noisy activity, as hundreds of geese become thousands, and a wall of sound envelops the landscape. Upon their arrival, the geese will congregate across the surrounding mudflats, salt marsh, and grasslands, using this part of the island as a meeting location to socialise and gather, before eventually spreading across Islay as winter progresses. Though high numbers of birds do remain around Gruinart throughout, Bridgend is also an important location with both of these sites situated on tidal sea lochs; they are used as key roost sites. Thousands of geese roost together on the loch, mudflats and salt marsh for safety.</p>
                  <p className="mb-4">The two key species we have as wintering tenants are the Barnacle Geese, and to a lesser extent the Greenland White-fronted Goose. Both very different looking species of geese, but equally as charismatic. In recent years, around 30,000 Barnacle Geese and 5,500 Greenland Whitefronted spent the winter on Islay. Their calls provide an indicative soundtrack to winter on the Queen of the Hebrides</p>
                  
                </div>
                <div className="col-sm-6">
                  <p className="mb-4">Barnacle Geese are unmistakable in their pied appearance; they have a distinctive black neck, head and breast, silvery belly, and sport a creamywhite face. These are by far the most numerous goose and are easily seen from the roadsides as they graze on the grasslands, foraging for leafy grasses. You’d be hard pressed to visit Islay during the winter months and not see several hundred of these birds without even trying - approximately 60 per cent of the Greenland population of Barnacle Geese spend the winter with us on Islay.</p>
                  <p className="mb-4">My particular favourite is the Greenland Whitefronted Goose, a gorgeous dark brown bird with white under-tail feathers and black blotches or ‘tiger stripes’ on the belly of the adults; these markings being unique to each individual bird, much like a fingerprint to us. Other more distinctive features are their bright-orange legs and bill, and the classic white on the forehead of adults, giving them their namesake attribute. White-fronted Geese tend to socialise in family groups, and prefer peatland and damp meadow habitats, something we have in spades out here. Unlike the more numerous Barnacle Goose, the white-fronts don’t roost on sea lochs and salt marsh, instead choosing to roost on the bog pools of local moorland and peatland.</p>
                </div>
              </div>
              <img className="img-fluid mb-4"
                src={require("../../Images/article6-right-img1.jpg")}
              />
            </div>

            <div className="" ref={secondContainer}>
              <img className="img-fluid mb-4 mb-sm-5"
                src={require("../../Images/article6-right-img2.jpg")}
              />
              <h2 className="mb-4 text-purple f-lora-i pe-3 lh-base text-center">So why do so many geese come to Islay?</h2>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <p className="mb-4">Islay has an oceanic climate and doesn’t sit very high above sea level, and so has an abundance of grassland, arable land, stubble, fen, and large areas of estuarine and salt marsh habitats on the lower ground, providing perfect conditions for foraging and roosting geese. Nature reserves such as RSPB The Oa, and in particular RSPB Loch Gruinart manage large areas of their grassland and wet meadow habitat to provide feeding grounds for the geese throughout the winter - Gruinart being an internationally import wintering site for both of these species. An area of wet grassland features known as ‘the Gruinart flats’ is vitally important for feeding geese and wading birds. Huge numbers can easily be seen from the road that goes through this location and it’s well worth stopping in one of the many lay-bys to soak in the wildfowl ambience with stunning views.</p>
                  <p className="mb-4">We are also joined by Greylags, Brent Geese, and the occasional Pink-footed Geese. Most years, the occasional rarer vagrants are recorded, species including Red-breasted Geese, Todd’s Canada Geese, Lesser White-Fronted Geese, and Cackling Geese; caught up in the flocks of Barnacles and White-fronts as they travelled south on their migration. Trying to pick out these odd rarities amongst a sea of several hundred other geese isn’t always a picnic, but a challenge that the wintering twitchers are always geared up for.</p>
                  
                </div>
                <div className="col-sm-6">
                  <p className="mb-4">In recent years, the abundance of so many geese hasn’t gone unnoticed. White-tailed Eagles, the largest raptor in the UK, have rapidly learnt to take advantage of this bountiful food source. These massive birds of prey now gather in larger numbers than ever before and annually set their sights on this wintertime feast. It’s no surprise that White-tailed Eagles from across Scotland make their return to Islay to take advantage of such prey availability. For the younger eagles that join us, this is an excellent opportunity to practice and hone their hunting skills whilst food opportunities are so fruitful. The drama of an eagle hunt is an incredibly exciting event, the goose flock exploding into the sky in an adrenaline-fuelled cacophony of noisy wing beats and frantic vocalisations, with massive eagles cutting through the flock to grab an unfortunate victim.</p>
                  <p className="mb-4">If you’re on Islay between October and April and you want to savour something that isn’t served in drams, then you have to experience the sight and sound of thousands of overwintering geese. A nature spectacle up there with some of the best, and right here in Scotland.</p>
                </div>
              </div>
            </div>
        </div>

      </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article6;
